import { z } from 'zod/v4'

export const limitationValidation = () => {
  return z.object({
    my_products: z.coerce.number().min(1, { message: 'Form is required' }).nonnegative({ message: 'Value must be at least 0' }),
    my_products_limit: z.boolean(),
    product_by_url: z.coerce.number().min(1, { message: 'Form is required' }).nonnegative({ message: 'Value must be at least 0' }),
    product_by_url_limit: z.boolean(),
  })
}